import React, { Component } from 'react';

import "./Calendar.scss"
import data from "../../api/data.json"
import CalendarHead from "./components/Calendar-Headers/Calendar-Headers"
import CalendarBoard from "./components/Calendar-Board/Calendar-Board"
import CalendarMonths from "./components/Calendar-Months/Calendar-Months"

class Calendar extends Component {
  constructor() {
    super();
    this.updateBoard = this.updateBoard.bind(this);
    this.state = {
      board: 0
    }
  }
  updateBoard(month) {
    this.setState({
      board: month
    });
  }
  render() {
    return (
      <section className="section section-calendar">
        <CalendarHead data={data.calendar.headers} />
        <div className="padding">
        <CalendarMonths updateBoard={this.updateBoard} />
        <CalendarBoard currBoard={this.state.board} />
        </div>
      </section>
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/Calendar/Calendar.js